module.exports = __webpack_public_path__ + "assets/img/be-partner-alert.5bc08879.png";